import D1GradRate from './D1GradRate.component';

export default D1GradRate;
